import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class AudiometriaTonal extends Examen {
  id = 14;
  code = 'AUDIO';
  name = 'AUDIOMETRIA';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'AUDIOMETRIA',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],
        puestoTrabajador: ['',  [Validators.required]],
        fechaIngresoEmpresa: ['',  [Validators.required]],

        antiguedadPuestoTrabajador: ['',  [Validators.required]]
      },
      numberForm: 2,
    },
    {
      name: 'Cuadro de Audiometría',
      fields: {},
      numberForm: 3,
    },
    {
      name: 'Datos del Audiómetro',
      fields: {
        marca: ['', [Validators.required, Validators.maxLength(100)]],
        fechaUltimaCalibracion: ['',  [Validators.required]],
        modelo: ['', [Validators.required, Validators.maxLength(100)]],
        numeroSerie: [null, [Validators.required,Validators.max(2147483647)]],
        estudioRealizadoEmpresa: [true, [Validators.required]],
        estudioRealizadoCabina: [false, [Validators.required]]
    },
      numberForm: 4,
    },
    {
      name: 'Otoscopía',
      fields: {
        pabellonAuricular: [null],
        pabellonAuricularNormal: [null],
        pabellonAuricularAnormal: [null],
        pabellonAuricularDescripcionAnormal: [{ value: '', disabled: true },[Validators.maxLength(250)]],
        conductoAuditivoExterno: [null],
        conductoAuditivoExternoNormal: [null],
        conductoAuditivoExternoAnormal: [null],
        conductoAuditivoExternoDescripcionAnormal: [{ value: '', disabled: true },[Validators.maxLength(250)]],
        membranaTimpanica: [null],
        membranaTimpanicaNormal: [null],
        membranaTimpanicaAnormal: [null],
        membranaTimpanicaDescripcionAnormal: [{ value: '', disabled: true },[Validators.maxLength(250)]]
      },
      numberForm: 5,
    },
    {
      name: 'Cuestionario Técnico',
      fields: {
        ambienteRuidoso: [false, [Validators.required]],
        acufenos: [false, [Validators.required]],
        ruidoExtralaboral: [false, [Validators.required]],
        entenderConversacion: [false, [Validators.required]],
        proteccionAuditiva: [false, [Validators.required]],
        listaProtectores: [{ value: '', disabled: true }],
        reposoAuditivo: [false,  [Validators.required]],
        indemnizadoHipoacusia: [false,  [Validators.required]],
        grita: [false,  [Validators.required]],
        capacitacionEpp: [false,  [Validators.required]],
        proteccionAuditivaObligatoria: [false,  [Validators.required]],
        proteccionAuditivaNoProvista: [false,  [Validators.required]],
        inconvenientes: [false,  [Validators.required]],
        inconvenientesDescipcion: ['', [Validators.maxLength(250)]]
      },
      numberForm: 6,
    },
    {
      name: 'Cuestionario Clínico',
      fields: {
        padecidoUltimoAnio: [false,  [Validators.required]],
        infeccionOido: [false,  [Validators.required]],
        dolorOido: [false,  [Validators.required]],
        supuracion: [false,  [Validators.required]],
        taponCera: [false,  [Validators.required]],
        padecidoOtro: [false,  [Validators.required]],
        padecidoNada: [false, [Validators.required]],
        padecidoOtroDescripcion: [{value:'', disabled: true}, [Validators.maxLength(200)]],
        enfermedades: [false,  [Validators.required]],
        enfermedadesDescripcion: ['',  [Validators.maxLength(250)]],
        exposicionesOtotoxicas: [false,  [Validators.required]],
        exposicionesOtotoxicasDescripcion: ['',[Validators.maxLength(250)]]
      },
      numberForm: 7,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ '', [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ), ] ],
        codigoDictamen: [ '', [ Validators.required ] ],
        medicoMatricula: ['',  [Validators.required]],
        medicoEspecialidad: ['',  [Validators.required]]
      },
      numberForm: 8,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 9,
    }
  ];

  constructor( formBuilder: FormBuilder ) {
    super( formBuilder );
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}
